enum TokenAction {
    Stealing=1, Kicking, Fleeing
}

export default TokenAction